export default __webpack_public_path__ + "static/media/success.c88c980e.gif";